import { useSyncExternalStore } from 'react'

const subscribe = (callback: () => void) => {
  window.addEventListener('online', callback)
  window.addEventListener('offline', callback)

  return () => {
    window.removeEventListener('online', callback)
    window.removeEventListener('offline', callback)
  }
}

const getSnapShot = () => navigator.onLine

const getServerSnapshot = () => true

export const useOnlineStatus = () =>
  useSyncExternalStore(subscribe, getSnapShot, getServerSnapshot)
